import { ApiError } from '../client';
import { getEnableDeliveryMockError, markDeliveryRestoredInMock } from './deliveryDetail';

// Mock of the restore WRITE: simulate latency, then either reject with an injected backend error
// code (dev/test hook, so the case-specific banners are exercisable) or flip the delivery to its
// computed collectable state in the shared detail mock, so a follow-up fetchDeliveryDetailMock
// returns the restored state. Idempotent, like the real endpoint is asked to be.
export async function enableDeliveryMock(id: string): Promise<void> {
  await new Promise((resolve) => setTimeout(resolve, 100));
  const injected = getEnableDeliveryMockError();
  if (injected !== null) {
    throw new ApiError(409, injected, { code: injected }, `restore failed: ${injected}`);
  }
  markDeliveryRestoredInMock(id);
}
